/* eslint-disable no-unused-vars */
import { useEffect, useState } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { useSettingContext } from '@context/SettingContent';
import { Button, Input, CustomDropdown } from '@components';
import { providerLabel } from '@helpers/setting';

import sty from '@flow/AuthWrapper/auth.module.scss';
import style from './psp.module.scss';

const SEARCH_ICON = '/images/search-icon.svg';
const CLOSE_ICON = '/images/close-icon.svg';
const WARNING_ICON = '/images/warning-red.svg';

// how many required field
const TOTAL_FIELD = 2;

export default function OtherDetail({
  handleDataObj,
  handleRegister,
  handleCountry,
  handleFormType,
  showPspList,
  dataObj,
  loading,
  country,
}) {
  const { metaData } = useSettingContext();

  const [searchPsp, handleSearchPsp] = useState('');
  const [selectPsp, handleSelectPsp] = useState(false);
  const [isFormPristine, handleFormPristine] = useState(true);

  // for form submission
  const [hasError, handleHasError] = useState({});
  const [fieldCount, handleFieldCount] = useState(0);
  const [canSubmit, handleCanSubmit] = useState(false);

  useEffect(() => {
    if (
      canSubmit &&
      fieldCount >= TOTAL_FIELD &&
      !Object.keys(hasError).length &&
      dataObj.psp?.label
    ) {
      handleRegister();
      handleCanSubmit(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [canSubmit, fieldCount, hasError, dataObj.psp]);

  function updateField(name, value) {
    handleCanSubmit(false);
    handleDataObj(state => ({ ...state, [name]: value }));
  }

  function updateSelect(value) {
    handleCanSubmit(false);

    handleCountry(value);
  }

  function handleError({ name, value }) {
    const errors = { ...hasError };

    if (!isFormPristine) {
      handleFieldCount(state => (state === TOTAL_FIELD ? TOTAL_FIELD : state + 1));
    }
    if (value) {
      errors[name] = 'error';
    } else {
      delete errors[name];
    }

    handleHasError(errors);
  }

  function handleFormChange() {
    if (isFormPristine) {
      handleFormPristine(false);
    }
    handleCanSubmit(true);
  }

  function handleSelected(psp) {
    handleCanSubmit(false);
    handleSelectPsp(false);
    handleDataObj(state => ({ ...state, psp }));
  }

  function getCountries() {
    return metaData.country.reduce(
      (arr, data) =>
        arr.concat({
          label: data.label,
          value: data.id,
        }),
      [],
    );
  }

  function comparePsp(a, b) {
    if (a.label.toUpperCase() > b.label.toUpperCase()) {
      return -1;
    }
    if (a.label.toUpperCase() < b.label.toUpperCase()) {
      return 1;
    }
    return 0;
  }

  return (
    <>
      {selectPsp ? (
        <section className={style['modal-wrap']}>
          <button className={style['close-icon']} onClick={() => handleSelectPsp(false)}>
            <img src={CLOSE_ICON} alt="close-icon" />
          </button>
          <div className={style.search}>
            <input type="text" value={searchPsp} onChange={e => handleSearchPsp(e.target.value)} />
            <span>
              <img src={SEARCH_ICON} alt="search-icon" />
            </span>
          </div>
          <div className={style['psp-list']}>
            {metaData?.service_provider?.sort(comparePsp).map(psp => {
              const renderData = (
                <button
                  key={psp.id}
                  className={style['psp-item']}
                  onClick={() => handleSelected(psp)}
                >
                  <span className={style['psp-img']}>{providerLabel(psp) || ''}</span>
                  <span>{psp.label || ''}</span>
                </button>
              );
              if (!searchPsp || psp.label.toLowerCase().includes(searchPsp.toLowerCase())) {
                return renderData;
              }
              return '';
            })}
          </div>
        </section>
      ) : (
        ''
      )}
      <div className={style['psp-btn']}>
        <button onClick={() => handleSelectPsp(true)}>
          {dataObj.psp?.label ? (
            <span className={style['selected-text']}>{dataObj.psp?.label}</span>
          ) : (
            <>
              <span className={style['placeholder-text']}>Your Payment Service Provider</span>
              <img src={SEARCH_ICON} alt="search-icon" />
            </>
          )}
        </button>
        {canSubmit && !dataObj.psp?.label ? (
          <div className="errors-wrapper">
            <img src={WARNING_ICON} alt="warning-icon" />
            <p className="error">Select Payment Provider</p>
          </div>
        ) : null}
      </div>
      <Input
        type="text"
        name="merchant"
        placeholder="Your Merchant Number"
        initialValue={dataObj.merchant}
        validations={[
          {
            validation: /(.*[A-Za-z0-9]){1}/i,
            message: 'Invalid Number',
          },
        ]}
        pristine={isFormPristine}
        onChange={value => updateField('merchant', value)}
        onError={errorValue => handleError(errorValue)}
      />
      <div className={cx('d-flex', style['country-selector'])}>
        <div className={style.label}>Country</div>
        <CustomDropdown
          className="auth-select"
          name="country"
          initialValue={country}
          pristine={isFormPristine}
          placeholder="Select"
          onChange={value => updateSelect(value)}
          onError={errorValue => handleError(errorValue)}
          getOption={getCountries()}
        />
      </div>

      <Button
        className={cx(sty['edit-actions'], { 'edit-actions': loading })}
        type={2}
        colorType={2}
        labelBack="Back"
        handleClickBack={() => handleFormType(2)}
        label={loading ? 'Loading...' : 'Register'}
        handleClickNext={handleFormChange}
      />
    </>
  );
}

OtherDetail.propTypes = {
  handleFormType: PropTypes.func,
  showPspList: PropTypes.func,
  handleDataObj: PropTypes.func,
  dataObj: PropTypes.object.isRequired,
  handleCountry: PropTypes.func,
  handleRegister: PropTypes.func,
  loading: PropTypes.bool,
  country: PropTypes.object,
};
